// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAvDsQRN4VknfGj7KGrZoCPE8ZTkhK5_Yc",
  authDomain: "ema-john-62712.firebaseapp.com",
  projectId: "ema-john-62712",
  storageBucket: "ema-john-62712.appspot.com",
  messagingSenderId: "907677199874",
  appId: "1:907677199874:web:9221460ea12e240f19c11b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;